import { TArticleMenuItem } from 'api/contentful/articles'
import { SLink } from 'components/articles/articleContentTable/styled'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { encodeQuery } from 'utils/fetcher'

export const ArticleContentTableItem = (props: {
  articleItem: TArticleMenuItem
  onLinkClick: () => void
}) => {
  const router = useRouter()
  const isInside = router.query.inside as string

  const customLink = props.articleItem?.customLink

  if (customLink) {
    return (
      <Link href={customLink} passHref legacyBehavior>
        <SLink onClick={props.onLinkClick}>{props.articleItem?.title}</SLink>
      </Link>
    )
  } else {
    const article = props.articleItem?.article
    return (
      <Link
        href={encodeQuery(`/articles/${article?.slug}`, { inside: isInside })}
        passHref
        legacyBehavior
      >
        <SLink onClick={props.onLinkClick} active={article?.slug === router.query.articleSlug}>
          {props.articleItem?.title}
        </SLink>
      </Link>
    )
  }
}
